/**
 * Shared derivations for a loyalty tier row as `member/tier-info` returns it.
 *
 * LoyaltyTierBenefit.vue and GetMemberShip.vue both render a tier's Condition
 * and Benefit lists. They each carried their own 35-line copy of this logic and
 * had already started to drift — the same copy-paste that had to be untangled
 * in the member portal (TierConditionList.vue).
 */

/**
 * "Condition to achieve tier" rows. Returns [{ text, completed? }].
 */
export const tierConditions = (tier) => {
  if (!tier || !tier.id) {
    return [];
  }

  const lines = [
    { text: tier.is_paid_member_ship ? "Paid Membership" : "Free Membership" },
  ];

  if (tier.is_paid_member_ship && tier.already_achieved_a_paid_tier_previously) {
    lines.push({ text: "Already achieved a paid tier previously" });
  }

  if (tier.is_paid_member_ship) {
    lines.push({
      text: "Membership Fee " + tier.membership_fee_total_format,
      completed: !!tier.completed_payment_membership_fee,
    });
  }

  if (tier.spending_achieve_tier > 0 && tier.spending_achieve_tier_format) {
    lines.push({
      text: tier.upgrade_tier_by_admissions
        ? "Visit " + tier.visit_achieve_tier_format + " times"
        : "Spend " + tier.spending_achieve_tier_format,
    });
  }

  if (tier.duration_achieve_membership) {
    lines.push({
      text:
        "Remain loyalty for " +
        tier.duration_achieve_membership +
        " " +
        (tier.duration_achieve_membership_unit_text
          ? tier.duration_achieve_membership_unit_text.label
          : ""),
    });
  }

  return lines;
};

/**
 * Benefit rows. Returns [{ title, lines }] — a benefit is either one line of
 * text (the cashback rules) or a titled group whose lines the API joined with
 * '---'.
 */
export const tierBenefits = (tier) => {
  if (!tier || !tier.id) {
    return [];
  }

  const list = [];
  const addLine = (text) => {
    if (text) {
      list.push({ title: text, lines: [] });
    }
  };

  addLine(tier.standard_rule_text);
  addLine(tier.superior_rule_text);

  if (tier.welcome_voucher_text) {
    list.push({
      title: "Welcome benefit",
      lines: tier.welcome_voucher_text.split("---").filter((line) => line),
    });
  }

  addLine(tier.welcome_direct_cashback_text);

  if (tier.birthday_voucher_text) {
    list.push({
      title: "Birthday benefit",
      lines: tier.birthday_voucher_text.split("---").filter((line) => line),
    });
  }

  return list;
};
